import { QueuePriorityEnum } from '../../enums';

export interface AutomationWorker {
  _id: string;
  uuid: string;
  socketId: string;
  configuration: AutomationWorkerConfiguration;
  status: WorkerStatusEnum;
  isSalesAccount: boolean;
}

export interface AutomationWorkerConfiguration {
  priority: QueuePriorityEnum;
  priorityTeamId: string | null;
  priorityQueueId: string | null;
}

export enum WorkerStatusEnum {
  Offline,
  Online
}
